import { connect } from 'react-redux';
import SuccessPage from './success-page.component';
import { State } from 'widgets/free-content/root/root.reducers';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

import { ISuccessPageStoreProps } from './success-page.types';

const mapStateToProps = (state: State): ISuccessPageStoreProps => {
    const brandedInstallerUrl = state.config.freeContent?.brandedInstallerUrl;
    const hasBrandedInstaller = state.config.freeContent?.useBrandedInstallerUrl ?? false;
    const platforms = state.event.data?.platforms ?? [];
    const pcPlatform = platforms.find(
        ({ platform }: { platform: string }) => platform === PLATFORM_TYPES.PC
    );

    return {
        shouldInheritStyles: state.config.shouldInheritStyles ?? false,
        gameId: pcPlatform?.gameId ?? '',
        hasBrandedInstaller,
        brandedInstallerUrl
    };
};

export default connect<ISuccessPageStoreProps>(
    mapStateToProps
)(SuccessPage);
